export const UNIT_STRING: any = {
  KILOGRAMS: 'kg',
  GRAMS: 'g',
}
